const truncateStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '4px 2px'
};

export const volunteersTableColumns = [
    {
        name: 'Device ID',
        selector: row => row.device_id,
        sortable: true,
        center: true,
        width: '150px',
        style: truncateStyle,
    },
    {
        name: 'Volunteer',
        selector: row => row.volunteer_name,
        sortable: true,
        center: true,
        width: '180px',
        cell: row => (
            <div style={{ 
                ...truncateStyle,
                color: '#5C61F2', 
                fontWeight: 'bold',
                width: '100%',
                textAlign: 'center'
            }}>
                {row.volunteer_name}
            </div>
        ),
    },
    {
        name: 'Mobile No',
        selector: row => row.mobile_no,
        sortable: true,
        center: true,
        width: '180px',
        style: truncateStyle,
    },
    {
        name: 'Download',
        selector: row => row.download_count,
        sortable: true,
        center: true,
        width: '150px',
        cell: row => (
            <span style={{
                
                padding: '4px 8px',
                borderRadius: '12px',
                fontSize: '12px'
            }}>
                {row.download_count}
            </span>
        ),
    },
    {
        name: 'Active Users',
        selector: row => row.active_users,
        sortable: true,
        center: true,
        width: '150px',
        style: truncateStyle,
    },
    {
        name: 'Badge',
        selector: row => row.badge,
        sortable: true,
        center: true,
        width: '120px',
        cell: row => (
            <div style={{ textAlign: 'center' }}>
                {row.badge === 'platinum' && <span style={{ color: '#FFD700', fontSize: '16px' }}>Platinum</span>}
                {row.badge === 'gold' && <span style={{ color: '#FFD700', fontSize: '16px' }}>Gold</span>}
                {row.badge === 'silver' && <span style={{ color: '#C0C0C0', fontSize: '16px' }}>Silver</span>}
                {row.badge === 'bronze' && <span style={{ color: '#CD7F32', fontSize: '16px' }}>Bronze</span>}
                {!['platinum','gold', 'silver', 'bronze'].includes(row.badge) && <span>No Badge</span>}
            </div>
        ),
    },
    {
        name: 'Location',
        selector: row => row.location,
        sortable: true,
        center: true,
        width: '180px',
        style: truncateStyle,
    }
];